import { z } from 'zod';
import { InterimCareSummarySupportProgressSchema } from './InterimCareSummarySupportProgressSchema';

// Bug in formik, it does not show formik.errors for arrays
// https://github.com/jaredpalmer/formik/issues/1116
// Validate the list with the schema instead
export const InterimCareSummarySupportProgressListSchema = z.array(
  InterimCareSummarySupportProgressSchema,
);
